import { useContext } from 'react';

import { AlertContext, AlertParams } from '../utilities/alert';

const useAlert = (): AlertParams => {
  return useContext(AlertContext);
};

export default useAlert;
